/* WRC enhancements delegate variant, availability, pricing, gallery and cart actions to Turbo. */
(function () {
  function initNativeProducts(scope) {
    (scope || document).querySelectorAll('[data-wrc-native-product]').forEach(function (root) {
      if (root.dataset.wrcNativeInitialized === 'true') return;
      root.dataset.wrcNativeInitialized = 'true';
    var dialog = root.querySelector('[data-wrc-native-size-dialog]');
    var open = root.querySelector('[data-wrc-native-size-open]');
    var close = root.querySelector('[data-wrc-native-size-close]');
    var lastFocus;
    if (dialog && open) {
      open.addEventListener('click', function () { lastFocus = document.activeElement; dialog.showModal(); });
      if (close) close.addEventListener('click', function () { dialog.close(); });
      dialog.addEventListener('click', function (event) { if (event.target === dialog) dialog.close(); });
      dialog.addEventListener('close', function () { if (lastFocus) lastFocus.focus(); });
    }

    var form = root.querySelector('[data-product-form]');
    var nativeButton = form && form.querySelector('[data-wrc-native-atc]');
    var sticky = document.querySelector('[data-wrc-native-sticky]');
    if (form && nativeButton) {
      var stickyButton = sticky && sticky.querySelector('[data-wrc-native-sticky-add]');
      var stickyPrice = sticky && sticky.querySelector('[data-wrc-native-sticky-price]');
      var stickyTitle = sticky && sticky.querySelector('[data-wrc-native-sticky-variant]');
      var buttonText = nativeButton.querySelector('.text');
      var productData;

      try {
        productData = JSON.parse(form.dataset.product);
      } catch (error) {
        productData = null;
      }

      function selectedVariantIsUnavailable() {
        var variantSelect = form.querySelector('select[name="id"]');
        if (!productData || !Array.isArray(productData.variants) || !variantSelect) {
          return nativeButton.disabled || nativeButton.classList.contains('disabled');
        }

        var selectedVariant = productData.variants.find(function (variant) {
          return String(variant.id) === String(variantSelect.value);
        });

        return !selectedVariant || selectedVariant.available !== true;
      }

      function syncPurchaseUI() {
        var checked = form.querySelector('.swatch input:checked');
        var priceNode = root.querySelector('[data-price-ui] > .price > .money, [data-price-ui] .price .money, .current_price .money');
        var price = priceNode ? priceNode.textContent.trim() : '';
        var unavailable = selectedVariantIsUnavailable();
        var submitting = !unavailable && (nativeButton.disabled || nativeButton.classList.contains('disabled'));
        var nextLabel = unavailable ? 'SOLD OUT' : 'ADD TO CART' + (price ? ' — ' + price : '');
        if (buttonText && buttonText.textContent.trim() !== nextLabel) buttonText.textContent = nextLabel;
        if (stickyTitle && checked) stickyTitle.textContent = checked.value;
        if (stickyPrice && price) stickyPrice.textContent = price;
        if (stickyButton) {
          stickyButton.disabled = unavailable || submitting;
          if (stickyButton.textContent !== nextLabel) stickyButton.textContent = nextLabel;
        }
      }

      form.addEventListener('change', function () { window.setTimeout(syncPurchaseUI, 0); });
      new MutationObserver(syncPurchaseUI).observe(nativeButton, { attributes: true, childList: true, subtree: true });
      var priceContainer = root.querySelector('[data-price-ui]');
      if (priceContainer) new MutationObserver(syncPurchaseUI).observe(priceContainer, { childList: true, subtree: true, characterData: true });
      if (stickyButton) stickyButton.addEventListener('click', function () { nativeButton.click(); });
      syncPurchaseUI();
      if (sticky && 'IntersectionObserver' in window) {
        new IntersectionObserver(function (entries) { sticky.hidden = entries[0].isIntersecting; }, { threshold: 0 }).observe(nativeButton);
      }
    }

    var gallery = root.querySelector('[data-product-gallery]');
    var counter = root.querySelector('[data-wrc-gallery-counter] span');
    if (gallery && counter) {
      var attempts = 0;
      var connectGalleryCounter = function () {
        var flickity = window.Flickity && window.Flickity.data(gallery);
        if (flickity) {
          var updateCounter = function () { counter.textContent = String(flickity.selectedIndex + 1); };
          flickity.on('select', updateCounter);
          updateCounter();
          return;
        }
        attempts += 1;
        if (attempts < 50) window.setTimeout(connectGalleryCounter, 100);
      };
      connectGalleryCounter();
    }
    });
  }

  function bootNativeProducts() { initNativeProducts(document); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', bootNativeProducts);
  else bootNativeProducts();
  document.addEventListener('shopify:section:load', function (event) { initNativeProducts(event.target); });
})();
